/**
 * @Author: Calvin Green <calvin>
 * @Date:   2022-03-01T13:12:28+02:00
 * @Email:  calvin@diversitude.com
 * @Last modified by:   calvin
 * @Last modified time: 2022-06-22T20:33:51+02:00
 * @Copyright: Diversitude 2022
 */



//eslint-disable-next-line
import axios from "axios";

const base = process.env.VUE_APP_API_BASEURL;

export const state = {
    admin_users: null,
    clients: null,
    client_data: null,
    client_step_data: null,
    client_levels: null,
    module_types: null,
};



export const mutations = {
    setAdminUsers(state, payload){
        state.admin_users = payload;
    },
    setClients(state, payload){
        state.clients = payload;
    },
    setClientData(state, payload){
        state.client_data = payload;
    },

    setClientStepData(state, payload){
        state.client_step_data = payload;
    },

    setLevels(state, payload){
        state.client_levels = payload;
    },

    setModules(state, payload){
        state.module_types = payload;
    },
    resetStore(state, payload){
        state.admin_users = payload;
        state.clients = payload;
        state.client_data = payload;
        state.client_step_data = payload;
        state.client_levels = payload;
        state.module_types = payload;
    }

};

export const actions = {
    /*eslint-disable-next-line */
    addUserTask({commit}, params){
        return new Promise((resolve, reject) => {
            axios.post( base + 'api/ccbadmin/addstepaction', params)
            .then( () =>{
                resolve();
            })
            .catch((error)=>{
                console.log(error)
                reject();
            })
        })
    },
    /*eslint-disable-next-line */
    addTask({commit}, params){
        return new Promise((resolve, reject) => {
            axios.post( base + 'api/ccbadmin/addstepaction', params)
            .then( () =>{
                resolve();
            })
            .catch((error)=>{
                console.log(error)
                reject();
            })
        })
    },
    loadAdminUsers({commit}){
        return new Promise((resolve, reject)=>{
            axios.get( base + 'api/ccbadmin/adminusers')
            .then((response)=>{
                commit('setAdminUsers', response.data);
                resolve();
            })
            .catch(()=>{
                reject();
            })
        })
    },
    loadClients({commit}){
        return new Promise((resolve, reject)=>{
            axios.get( base + 'api/ccbadmin/clients')
            .then((response)=>{
                commit('setClients', response.data);
                resolve();
            })
            .catch(()=>{
                reject();
            })
        })
    },
    loadClientData({commit}, id){
        return new Promise((resolve, reject)=>{
            axios.get( base + 'api/ccbadmin/client/' + id)
            .then((response)=>{
                commit('setClientData', response.data);
                resolve();
            })
            .catch((e)=>{
                console.log(e)
                reject();
            })
        });
    },
    //eslint-disable-next-line
    addClient({}, params){
        return new Promise((resolve, reject)=>{
            axios.post( base + 'api/ccbadmin/addclient', params)
            .then(()=>{
                resolve();
            })
            .catch(()=>{
                reject();
            })

        })
    },

    //eslint-disable-next-line
    saveAdminUser({}, params){/* (id, name, email, password, cell_no, designation, id_number, academic_qual, work_qual, years_experience */
        return new Promise((resolve, reject)=>{
            axios.post( base + 'api/ccbadmin/saveadminuser', params)
            .then(()=>{
                resolve();
            })
            .catch(()=>{
                reject();
            })
        })
    },
    loadClientStepData({commit}, params){/* params.client_id, params.step_id */
        return new Promise((resolve, reject)=>{
            axios.get( base + 'api/ccbadmin/clientstep/' + params.client_id + '/' + params.step_id)
            .then((response)=>{
                commit('setClientStepData', response.data);
                resolve();
            })
            .catch(()=>{
                reject();
            })
        })
    },

    /*eslint-disable-next-line */
    addComment({}, params){
        return new Promise((resolve, reject) => {
            axios.post( base + 'api/ccbadmin/addstepaction', params)
            .then( () =>{
                resolve();
            })
            .catch((error)=>{
                console.log(error)
                reject();
            })
        })
    },


    /*eslint-disable-next-line */
    markAsRead({}, params){
        return new Promise((resolve, reject) => {
            axios.post( base + 'api/ccbadmin/trackstepaction', params) // client_step_action_id
            .then( () =>{
                resolve();
            })
            .catch((error)=>{
                console.log(error)
                reject();
            })
        })
    },

    /*eslint-disable-next-line */
    deleteStepAction({}, params){
        return new Promise((resolve, reject) => {
            axios.post( base + 'api/ccbadmin/deletestepaction', params)
            .then( () =>{
                resolve();
            })
            .catch((error)=>{
                console.log(error)
                reject();
            })
        })
    },
    /*eslint-disable-next-line */
    validateStep({}, params){//lient_id, validation_check_id, validation_status
        return new Promise((resolve, reject)=>{
            axios.post( base + 'api/ccbadmin/validatestepitem', params)
            .then(()=>{
                resolve();
            })
            .catch(error => {
                console.log('Validate error', error)
                reject(error);
            })
        })
    },
    /*eslint-disable-next-line */
    distributeAllSOPs({}, params) {
        return new Promise((resolve, reject)=>{
            axios.post( base + 'api/ccbdocadmin/distributeall', params)
            .then(()=>{
                resolve();
            })
            .catch(error => {
                console.log('Validate error', error)
                reject(error);
            })
        })
    },
    /*eslint-disable-next-line */
    addClientAudit({}, params) {
        return new Promise((resolve, reject)=>{
            axios.post( base + 'api/ccbadmin/addclientaudit', params)
            .then(()=>{
                resolve();
            })
            .catch(error => {
                console.log('Validate error', error)
                reject(error);
            })
        })
    },
    /*From client store. used for organogram on the admin side*/
    loadClientLevels({commit}){
        return new Promise((resolve, reject)=>{
            axios.get( base + 'api/clientadmin/levels')
            .then((response)=>{
                console.log('Levels Data', response.data);
                commit('setLevels', response.data);
                resolve();
            })
            .catch(()=>{
                reject();
            })
        })
    },

    //* Load module types, displayed in dropdown when adding a client
    loadModuleTypes({commit}){
        return new Promise((resolve, reject)=>{
            axios.get( base + 'api/ccbadmin/modules')
            .then((response)=>{
                commit('setModules', response.data);
                resolve();
            })
            .catch(()=>{
                reject();
            })
        })
    },
    //* Load module types, displayed in dropdown when adding a client
    loadSopStats({commit}, params){/* params.client_id, params.step_id */
        return new Promise((resolve, reject)=>{
            axios.get( base + 'api/ccbdocadmin/sopstats/' + params.id )
            .then((response)=>{
                commit('setSopStats', response.data);
                resolve();
            })
            .catch(()=>{
                reject();
            })
        })
    },
    clearAll({commit}){
        return new Promise((resolve) => {
            commit('resetStore', null);
            resolve();
        })
    },
};
